import { CircularProgress } from "@mui/material";
import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { BsFiletypeJson as Json, BsFiletypeXlsx as Xlsx } from "react-icons/bs";
import { BsFullscreen as Fullscreen } from "react-icons/bs";
import { BsFullscreenExit as FullscreenExit } from "react-icons/bs";
import { BsTrash3 as Trash } from "react-icons/bs";
import { CiEraser as Erase } from "react-icons/ci";
import { FaMapMarker as MapMarker } from "react-icons/fa";
import { FaGear as Gears } from "react-icons/fa6";
import { FaRegCirclePause as Pause } from "react-icons/fa6";
import { FiAward as Award, FiCamera as CameraThick } from "react-icons/fi";
import { FiMoon as Moon } from "react-icons/fi";
import { GiReturnArrow as Return } from "react-icons/gi";
import { GrTemplate as Template } from "react-icons/gr";
import { GrDrag as DragHandle } from "react-icons/gr";
import { HiWrenchScrewdriver as WrenchScrewDriver } from "react-icons/hi2";
import { IoIosColorPalette as ColorPalette } from "react-icons/io";
import { IoMdMore as More } from "react-icons/io";
import { IoPeopleOutline as People } from "react-icons/io5";
import { IoDuplicateOutline as Duplicate } from "react-icons/io5";
import { LiaPlayCircleSolid as Play } from "react-icons/lia";
import {
  LuBan as Ban,
  LuBarChart3 as BarChart3,
  LuBuilding2 as Building2,
  LuCrop as Crop,
  LuFilter as Filter,
  LuLayers as Layers,
  LuMaximize2 as Maximize2,
  LuTrendingUp as TrendUp,
  LuZap as Zap,
} from "react-icons/lu";
import { PiPaintBrushBroad as PaintBrush } from "react-icons/pi";
import { SlEnergy as Energy } from "react-icons/sl";
import { TiExportOutline as Export } from "react-icons/ti";

import { ReactComponent as Add } from "../Asset/Icons/addSm.svg";
import { ReactComponent as ArrowBottomLeft } from "../Asset/Icons/arrowBottomLeft.svg";
import { ReactComponent as ArrowDown } from "../Asset/Icons/arrowDown.svg";
import { ReactComponent as ArrowRight } from "../Asset/Icons/arrowRight.svg";
import { ReactComponent as ArrowThinLeft } from "../Asset/Icons/arrowThinLeft.svg";
import { ReactComponent as ArrowThinRight } from "../Asset/Icons/arrowThinRight.svg";
import { ReactComponent as ArrowUpRight } from "../Asset/Icons/arrowUpRight.svg";
import { ReactComponent as Barchart } from "../Asset/Icons/barchart.svg";
import { ReactComponent as BatteryIcon } from "../Asset/Icons/battery.svg";
import { ReactComponent as BuildingIcon } from "../Asset/Icons/building.svg";
import { ReactComponent as BuildingTypeIcon } from "../Asset/Icons/buildingType.svg";
import { ReactComponent as Calendar } from "../Asset/Icons/calendar.svg";
import { ReactComponent as Camera } from "../Asset/Icons/camera.svg";
import { ReactComponent as CertificateIcon } from "../Asset/Icons/certificate.svg";
import { ReactComponent as Checkmark } from "../Asset/Icons/checkmark.svg";
import { ReactComponent as ChevronDown } from "../Asset/Icons/chevronDown.svg";
import { ReactComponent as ChevronLeft } from "../Asset/Icons/chevronSmLeft.svg";
import { ReactComponent as ChevronRight } from "../Asset/Icons/chevronSmRight.svg";
import { ReactComponent as Close } from "../Asset/Icons/close-md.svg";
import { ReactComponent as Coins } from "../Asset/Icons/coinsSm.svg";
import { ReactComponent as ConstructionIcon } from "../Asset/Icons/construction.svg";
import { ReactComponent as Contact } from "../Asset/Icons/contact.svg";
import { ReactComponent as Details } from "../Asset/Icons/details.svg";
import { ReactComponent as Download } from "../Asset/Icons/downloadSm.svg";
import { ReactComponent as Edit } from "../Asset/Icons/edit.svg";
import { ReactComponent as Exit } from "../Asset/Icons/exit.svg";
import { ReactComponent as EyeClose } from "../Asset/Icons/eyeClose.svg";
import { ReactComponent as Eyeglasses } from "../Asset/Icons/eyeglasses.svg";
import { ReactComponent as EyeOpen } from "../Asset/Icons/eyeOpen.svg";
import { ReactComponent as FlatCube } from "../Asset/Icons/flatCube.svg";
import { ReactComponent as GridIcon } from "../Asset/Icons/grid.svg";
import { ReactComponent as Handshake } from "../Asset/Icons/handshake.svg";
import { ReactComponent as Info } from "../Asset/Icons/infoSm.svg";
import { ReactComponent as ListIcon } from "../Asset/Icons/list.svg";
import { ReactComponent as LocationIcon } from "../Asset/Icons/location.svg";
import { ReactComponent as Piechart } from "../Asset/Icons/piechart.svg";
import { ReactComponent as Remove } from "../Asset/Icons/removeSm.svg";
import { ReactComponent as Settings } from "../Asset/Icons/settings.svg";
import { ReactComponent as Sorting } from "../Asset/Icons/sorting.svg";
import { ReactComponent as SortingAscending } from "../Asset/Icons/sortingAscending.svg";
import { ReactComponent as SortingDescending } from "../Asset/Icons/sortingDescending.svg";
import { ReactComponent as SquareHalf } from "../Asset/Icons/squareHalf.svg";
import { ReactComponent as Sun } from "../Asset/Icons/sun.svg";
import { ReactComponent as Tree } from "../Asset/Icons/tree.svg";
import { ReactComponent as Upload } from "../Asset/Icons/uploadSm.svg";
import { ReactComponent as Warning } from "../Asset/Icons/warning.svg";
import { ReactComponent as Wrench } from "../Asset/Icons/wrench.svg";
import { cn } from "../utils/styling";

const DISABLED_ICON_COLOR = "var(--color-foreground-disabled)";

const muiIcons = {
  CircularProgress,
} as const;

const reactIcons = {
  Award,
  Ban,
  BarChart3,
  Building2,
  CameraThick,
  ColorPalette,
  Crop,
  DragHandle,
  Duplicate,
  Energy,
  Erase,
  Export,
  Filter,
  Fullscreen,
  FullscreenExit,
  Gears,
  Json,
  Layers,
  MapMarker,
  Maximize2,
  Moon,
  More,
  PaintBrush,
  Pause,
  People,
  Play,
  Return,
  Template,
  Trash,
  TrendUp,
  WrenchScrewDriver,
  Xlsx,
  Zap,
} as const;

const localIcons = {
  Add,
  ArrowBottomLeft,
  ArrowDown,
  ArrowRight,
  ArrowThinLeft,
  ArrowThinRight,
  ArrowUpRight,
  Barchart,
  BatteryIcon,
  BuildingIcon,
  BuildingTypeIcon,
  Calendar,
  Camera,
  CertificateIcon,
  Checkmark,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Close,
  Coins,
  ConstructionIcon,
  Contact,
  Details,
  Download,
  Edit,
  Exit,
  EyeClose,
  Eyeglasses,
  EyeOpen,
  FlatCube,
  GridIcon,
  Handshake,
  Info,
  ListIcon,
  LocationIcon,
  Piechart,
  Remove,
  Settings,
  Sorting,
  SortingAscending,
  SortingDescending,
  SquareHalf,
  Sun,
  Tree,
  Upload,
  Warning,
  Wrench,
} as const;

export type IconName = LocalIconName | MuiIconName | ReactIconName;
type LocalIconName = keyof typeof localIcons;
type MuiIconName = keyof typeof muiIcons;
type ReactIconName = keyof typeof reactIcons;

const isMuiIconName = (name: IconName): name is MuiIconName => name in muiIcons;
const isReactIconName = (name: IconName): name is ReactIconName => name in reactIcons;

export type IconProps = {
  className?: string;
  color?: string;
  disabled?: boolean;
  fill?: string;
  iconName: IconName;
  onClick?: () => void;
  size?: "2xl" | "lg" | "md" | "sm" | "xl";
  stroke?: string;
  style?: CSSProperties;
  svgClassName?: string;
};

const sizeContainerClass: Record<NonNullable<IconProps["size"]>, string> = {
  "2xl": "h-12 w-12",
  lg: "h-8 w-8",
  md: "h-6 w-6",
  sm: "h-4 w-4",
  xl: "h-10 w-10",
};

export const Icon = ({
  className,
  color,
  disabled,
  fill,
  iconName,
  onClick,
  size = "sm",
  stroke,
  style,
  svgClassName,
}: IconProps) => {
  fill = (fill && disabled && DISABLED_ICON_COLOR) || fill;
  stroke = (stroke && disabled && DISABLED_ICON_COLOR) || stroke;
  color = (color && disabled && DISABLED_ICON_COLOR) || color;

  const svgRef = useRef<SVGElement>(null);

  const [fillColor, setFillColor] = useState<string | undefined>();
  const [strokeColor, setStrokeColor] = useState<string | undefined>();

  useEffect(() => {
    if (color && svgRef.current) {
      const strokeAttribute = svgRef?.current?.children[0].getAttribute("stroke");
      const fillAttribute = svgRef?.current?.children[0].getAttribute("fill");
      if (strokeAttribute !== null || fillAttribute === null) setStrokeColor(color);
      if (fillAttribute !== null) setFillColor(color);
    }
    if (fill) setFillColor(fill);
    if (stroke) setStrokeColor(stroke);

    if (!color && !fill && !stroke) {
      setFillColor(undefined);
      setStrokeColor(undefined);
    }
  }, [svgRef, color, fill, stroke]);

  const containerClassName = sizeContainerClass[size];

  const scaleClassName =
    size === "2xl"
      ? "scale-[2.5]"
      : size === "xl"
      ? "scale-[2.05]"
      : size === "lg"
      ? "scale-[1.95]"
      : size === "md"
      ? "scale-[1.48]"
      : "";
  const iconClassName = `${scaleClassName} ${svgClassName ?? ""}`;

  if (!iconName) return <span />;

  let renderedIcon: React.ReactNode;
  if (isMuiIconName(iconName)) {
    const SelectedIcon = muiIcons[iconName];
    const muiPaint = color || fill || stroke;
    renderedIcon = (
      <SelectedIcon
        className={iconClassName}
        sx={{
          color: muiPaint ?? "inherit",
        }}
      />
    );
  } else if (isReactIconName(iconName)) {
    const SelectedIcon = reactIcons[iconName];
    renderedIcon = <SelectedIcon className={iconClassName} color={color} />;
  } else {
    const SelectedIcon = localIcons[iconName];
    renderedIcon = <SelectedIcon className={iconClassName} color={color} ref={svgRef as React.Ref<any>} />;
  }

  const paintStyle: CSSProperties = {
    ...style,
    ...(fillColor ? { "--icon-fill": fillColor } : {}),
    ...(strokeColor ? { "--icon-stroke": strokeColor } : {}),
  };

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center",
        fillColor && "[&_path]:fill-[var(--icon-fill)]",
        strokeColor && "[&_path]:stroke-[var(--icon-stroke)]",
        onClick && "cursor-pointer",
        containerClassName,
        className
      )}
      onClick={onClick}
      style={paintStyle}
    >
      {renderedIcon}
    </span>
  );
};
